import Joi from 'joi-browser'
import moment from 'moment'

const dateSchema = Joi.date().timestamp()

const LOCATION_REQUIRED = 'Please enter a city or airport'
const UNIQUE_START_END_REQUIRED =
  'Departure and arrival airport should not match'
const INVALID_DATE = 'Please select valid dates'
const DISALLOW_INFANT_INTL_FLIGHT =
  'Priceline does not support lap infants on international flights'
const CHILD_AGE_REQUIRED =
  "Please enter children's age to get the best price for your group"
const TRAVELERS_PER_ROOM = 4
const ROOM_CAPACITY_ERROR =
  'Rooms accommodate up to 4 people. You may need additional rooms for your group'
const HOTEL_DATE_RANGE_ERROR = 'Hotel dates must fall between your flight dates'

// TODO: follow-up PR can adapt joi schemas to avoid imperative if statements
const validate = (
  {
    startLocation,
    startLocationObject,
    endLocation,
    endLocationObject,
    startDate,
    endDate,
    childrenCount,
    childrenAges,
    roomCount,
    adultCount,
    partialStay,
    hotelStartDate,
    hotelEndDate,
    tripType
  } = {}
) => {
  const errors = {}

  if (!startLocation && tripType !== 'STAY:DRIVE') {
    errors.startLocation = LOCATION_REQUIRED
  }

  if (!endLocation) {
    errors.endLocation = LOCATION_REQUIRED
  }

  // TODO: This validation seems like a safety, since typeahead API data
  // doesn't seem to have dups. But would keep this validation as the story
  // can pick the same city for both input locations and see the validation
  const locationValidation =
    startLocation && endLocation && startLocation === endLocation
  if (locationValidation) {
    errors.startLocation = UNIQUE_START_END_REQUIRED
    errors.endLocation = UNIQUE_START_END_REQUIRED
  }

  if (!startDate) {
    errors.startDate = INVALID_DATE
  } else {
    // type validation
    const startDateValidation = Joi.validate(startDate, dateSchema)
    if (startDateValidation.error) {
      errors.startDate = INVALID_DATE
    }
  }

  if (!endDate) {
    errors.endDate = INVALID_DATE
  } else {
    const endDateValidation = Joi.validate(endDate, dateSchema)
    if (endDateValidation.error) {
      errors.endDate = INVALID_DATE
    }
  }

  const intlStartLocation = !!(
    startLocationObject &&
    typeof startLocationObject.countryCode === 'string' &&
    startLocationObject.countryCode.toUpperCase() !== 'US'
  )

  const intlEndLocation = !!(
    endLocationObject &&
    typeof endLocationObject.countryCode === 'string' &&
    endLocationObject.countryCode.toUpperCase() !== 'US'
  )

  const isInfantFound = !!(
    Array.isArray(childrenAges) && childrenAges.find(age => age === '0')
  )

  const isStartLocationWithInfant = intlStartLocation && isInfantFound
  const isEndLocationWithInfant = intlEndLocation && isInfantFound

  if (isStartLocationWithInfant || isEndLocationWithInfant) {
    errors.intlLapInfant = DISALLOW_INFANT_INTL_FLIGHT
  }

  const isChildrenAgesArray = Array.isArray(childrenAges)
  const isChildrenAgeDataValid = isChildrenAgesArray && childrenAges.length >= 0
  const numOfValidAges =
    isChildrenAgesArray && childrenAges.filter(age => age >= 0)

  if (
    childrenCount > 0 &&
    isChildrenAgeDataValid &&
    childrenCount !== numOfValidAges.length
  ) {
    errors.childAge = CHILD_AGE_REQUIRED
  }

  const travelerCount = adultCount + childrenCount
  const allowedTravelerCount = roomCount * TRAVELERS_PER_ROOM
  if (allowedTravelerCount < travelerCount && tripType.includes('STAY')) {
    errors.roomCapacity = ROOM_CAPACITY_ERROR
  }

  if (partialStay) {
    if (!hotelEndDate) {
      errors.hotelEndDate = INVALID_DATE
    }
    if (
      startDate &&
      hotelStartDate &&
      moment(hotelStartDate).isBefore(moment(startDate))
    ) {
      errors.hotelStartDate = HOTEL_DATE_RANGE_ERROR
    }
    if (
      endDate &&
      hotelEndDate &&
      moment(hotelEndDate).isAfter(moment(endDate))
    ) {
      errors.hotelStartDate = HOTEL_DATE_RANGE_ERROR
    }
  }

  return errors
}

export default validate
